import { createContext, use } from 'react';
import type { ReactNode } from 'react';
import type { ApiClient } from '@sf/api';

const ApiContext = createContext<ApiClient | null>(null);

/** Makes the one customer API client available to the tree. Created in main.tsx from the runtime config. */
export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext value={client}>{children}</ApiContext>;
}

/**
 * The typed API client:
 *
 * ```tsx
 * const api = useApi();
 * const { data } = useQuery({ queryKey: ['devices'], queryFn: () => api.devices.list() });
 * ```
 */
export function useApi(): ApiClient {
  const ctx = use(ApiContext);
  if (!ctx) throw new Error('useApi must be used inside <ApiProvider>');
  return ctx;
}
